import { SocialMediaUserData } from './socialmedia-user-data.model';

export interface SocialMediaUserStatus {
  status: number; //related to SocialMediaUserStatusEnum
  userData: SocialMediaUserData;
}
